export default "__VITE_ASSET__C5TX_e$m__"